import { TableCell, TableHead, TableRow } from '@mui/material';
import classNames from 'classnames';
import { intersection } from 'lodash';
import * as React from 'react';
import shortid from 'shortid';

import { ORDER_REGISTRATION_FIELDS } from 'src/constants';

import { TableHeaderItem } from 'components/Filter/TableHeaderItem';

import { t } from 'utils';

import { racerFields } from '../../../../Filters';
import { MAIN_COLUMNS, PAYMENT_COLUMNS, COLUMN_WIDTH, CUSTOM_FIELD_WIDTH } from './columns';

type Props = {
  distance: DistanceType;
  checkedRequiredFields: AnyObject;
  hasPrice: boolean;
};

const classes = {
  thead: {
    custom: ['start-list-table-header', 'table-header', 'cell-custom'],
    regular: ['start-list-table-header', 'filter-item'],
  },
};

const WAVE_TYPE = 'wave';

class THead extends React.Component<Props> {
  getRequiredFields = (): any => {
    const { checkedRequiredFields } = this.props;

    const registrationFields = Object.keys(checkedRequiredFields).filter((filter) => !!(checkedRequiredFields as AnyObject)[filter]);

    return intersection(ORDER_REGISTRATION_FIELDS, registrationFields);
  };

  customFields = (): any => {
    const { distance } = this.props;

    const style = { width: CUSTOM_FIELD_WIDTH };

    return (distance.custom_fields || []).map((field) => (
      <TableCell className={classNames(...classes.thead.custom)} key={shortid.generate()} style={style}>
        {field.name}
      </TableCell>
    ));
  };

  _renderThLabels = (cols: Array<string>): React.ReactNode => {
    return cols.map((field) => {
      if (!this._isFieldShown(field)) {
        return null;
      }

      const width = COLUMN_WIDTH[field];
      const className = `cell-${field}`;
      const translation = `racers.list.table.${field}`;

      return (
        <TableHeaderItem
          key={field}
          name={field}
          width={width}
          className={classNames(...classes.thead.regular, className)}
          label={t(translation as TranslationLockedKeys) as any}
        />
      );
    });
  };

  _additionalFields = () => {
    const { checkedRequiredFields } = this.props;
    const registrationFields: Array<string> = Object.keys(checkedRequiredFields).filter(
      (filter) => !!(checkedRequiredFields as AnyObject)[filter] && this._isFieldShown(filter),
    );

    return intersection<string>(ORDER_REGISTRATION_FIELDS, registrationFields);
  };

  _isFieldShown = (field: string) => {
    const { distance, checkedRequiredFields, hasPrice } = this.props;

    switch (field) {
      case racerFields['wave_id']:
        return distance.start_type === WAVE_TYPE;
      case racerFields['class_id']:
        return !!distance.classes?.length;
      case racerFields['discipline_id']:
        return !!distance.disciplines?.length;
      case racerFields['external_swimrun_id']:
        return !!checkedRequiredFields['external_swimrun_id'];
      case racerFields['city']:
        return !!checkedRequiredFields['city'];
      case racerFields['country_id']:
        return !!checkedRequiredFields['country_id'];
      case racerFields['nationality_id']:
        return !!checkedRequiredFields['nationality_id'];
      case racerFields['order_refund_protect_amount']:
        return !!distance.refund_protect_enabled;

      case racerFields['order_coupon_codes']:
      case racerFields['order_id']:
      case racerFields['order_created_at']:
      case racerFields['order_total']:
      case racerFields['order_status']:
        return !!hasPrice;
      default:
        return true;
    }
  };

  render() {
    return (
      <React.Fragment>
        <TableHead>
          <TableRow>
            {this._renderThLabels(['action'])}
            {this._renderThLabels([...MAIN_COLUMNS, ...this.getRequiredFields()])}
            {this.customFields()}
            {this._renderThLabels([racerFields['order_refund_protect_amount']])}
            {this._renderThLabels([racerFields['external_swimrun_id']])}
            {this._renderThLabels([racerFields['added_at']])}
            {this._renderThLabels([racerFields['added_by']])}
            {this._renderThLabels(PAYMENT_COLUMNS)}
            {this._renderThLabels([racerFields['comment']])}
            {this._renderThLabels([racerFields['payment_status']])}
          </TableRow>
        </TableHead>
      </React.Fragment>
    );
  }
}

export { THead };
